import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";
import { useNavigate } from "react-router-dom";
import Layout from "../../layouts/Layout";
import ReCAPTCHA from "react-google-recaptcha";
import { Bounce, ToastContainer, toast } from 'react-toastify';

function SeoQuestionnaireForm() {
  const recaptcha = useRef();
  const form = useRef();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showGMB, setShowGMB] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    const formElements = form.current.elements;
    let isValid = true;

    // Loop through form elements to check for empty fields
    for (let i = 0; i < formElements.length; i++) {
      const element = formElements[i];
      if (element.hasAttribute("required") && !element.value) {
        isValid = false;
        element.focus();
        break;
      }
    }

    if (isValid) {
      const captchaValue = recaptcha.current.getValue();
      if (captchaValue) {
        setLoading(true);
       
        emailjs
          .sendForm(
            "service_2z2n80a", // Replace with your EmailJS service ID
            "template_n73cnam", // Replace with your EmailJS template ID
            form.current,
            "F60d83opzJ20A6FoL" // Replace with your EmailJS user ID
          )
          .then(
            (result) => {
              console.log("Email sent successfully:", result.text);
              toast('Your form has been submitted successfully.', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
                });
              setTimeout(() => {
                navigate("/")
              }, 2000);
            },
            (error) => {
              console.log("Error sending email:", error.text);
              alert("Failed. Please try again.");
            }
          )
          .finally(() => {
            setLoading(false);
          });
      } else {
        alert("Please fill Captcha")
      }
    }
  };

  return (
    <Layout header={1} footer={1} className="" mainClassName="">
      <div className="container" style={{ marginTop: "8rem" }}>
        <h2 className="text-center">SEO Questionnaire Form</h2>
        <form ref={form} onSubmit={handleSubmit} className="card p-4">
          {/* Contact Information */}
          <h4 className="mb-3">Contact Information</h4>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Business Name *</label>
              <input
                type="text"
                className="form-control"
                name="business_name"
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Business Number *</label>
              <input
                type="number"
                className="form-control"
                name="business_number"
                required
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Business Address *</label>
              <input
                type="text"
                className="form-control"
                name="business_address"
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Business Email</label>
              <input
                type="email"
                className="form-control"
                name="business_email"
              />
            </div>
          </div>
          <div className="mb-3">
            <label className="form-label">Your Role</label>
            <input type="text" className="form-control" name="your_role" />
          </div>

          {/* Business Information */}
          <h4 className="mt-4">Business Information</h4>
          <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">What is your website's URL? / If available.</label>
            <input type="url" className="form-control" name="website_url" />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">What kind of CMS was the website built on?</label>
            <input type="text" className="form-control" name="cms_website" />
          </div>

          </div>
          <div className="mb-3">
            <label className="form-label">What accesses are you able to provide from the following?</label>
            <select className="form-select" name="access">
              <option value="">Select an option</option>
              <option value="Website/CMS">Website/CMS</option>
              <option value="Google Search Console">
                Google Search Console
              </option>
              <option value="Google Analytics">Google Analytics</option>
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">
            Do you want to target a specific geographic area? (local, national, international, etc.) *
            </label>
            <input
              type="text"
              className="form-control"
              name="target_location"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Which industry does your company/business belong to? *</label>
            <input
              type="text"
              className="form-control"
              name="business_industry"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">What are your top 3 goals that you want to achieve with your digital marketing within the next 6 months?</label>
            <textarea
              className="form-control"
              rows="3"
              name="marketing_goals"
            ></textarea>
          </div>

          <div className="mb-3">
            <label className="form-label">Who are your specific target markets/customers? Please be as specific as you can *</label>
            <textarea
              className="form-control"
              rows="3"
              name="target_market"
              required
            ></textarea>
          </div>

          <div className="mb-3">
            <label className="form-label">What are your main objectives with SEO? (e.g., increase website traffic, rank for specific keywords, improve local search rankings, etc.) *</label>
            <textarea
              className="form-control"
              rows="3"
              name="seo_objectives"
              required
            ></textarea>
          </div>

          <div className="mb-3">
            <label className="form-label">
            Do you have a list of keywords or phrases you want to rank for? If so, please provide them.
            </label>
            <input type="text" className="form-control" name="keywords" />
          </div>

          <div className="mb-3">
            <label className="form-label">
            Have you ever had a Google penalty? *
            </label>
            
            <select className="form-select" name="google_penalty"> 
              <option value="Yes">Yes</option>
              <option value="No">No</option>
              <option value="Not Sure">Not Sure</option>
            </select>
          </div>
          {/* Client Lifetime Value */}
          <div className="mb-3">
            <label className="form-label">
            What is your average client lifetime value? 
            </label>
            <input
              type="text"
              className="form-control"
              name="client_lifetime_value"
            />
          </div>

          {/* Website Login Credentials */}
          <div className="mb-3">
            <label className="form-label">
              Please provide your website login credentials (cPanel, WordPress,
              Wix) *
            </label>
            <input
              type="text"
              className="form-control"
              name="website_login"
              required
            />
          </div>

          {/* Website Visitors */}
          <div className="mb-3">
            <label className="form-label">
              How many visitors (on your website) do you currently have in a
              month?
            </label>
            <input
              type="number"
              className="form-control"
              name="website_visitors"
            />
          </div>

          {/* Business Hours */}
          <div className="mb-3">
            <label className="form-label">
              What are your business hours? *
            </label>
            <input
              type="text"
              className="form-control"
              name="business_hours"
              required
            />
          </div>

          {/* Google My Business */}
          <div className="mb-3">
            <label className="form-label">
              Do you have a Google My Business (GMB) account? *
            </label>
            <div>
              <input
                type="radio"
                name="gmb_account"
                value="Yes"
                onChange={() => setShowGMB(true)}
              />{" "}
              Yes
              <input
                type="radio"
                name="gmb_account"
                value="No"
                className="ms-3"
                onChange={() => setShowGMB(false)}
              />{" "}
              No
            </div>
            <input
              type="url"
              className="form-control mt-2"
              name="gmb_link"
              placeholder="If yes, please provide the link"
              style={{ display: showGMB ? "block" : "none" }}
            />
          </div>

          {/* Business History */}
          <div className="mb-3">
            <label className="form-label">
              A brief history of your business? *
            </label>
            <textarea
              className="form-control"
              rows="3"
              name="business_history"
              required
            ></textarea>
          </div>

          <div class="mt-4">
            <div class="">
              <h3 class="fw-bold">Thank You!</h3>
              <p class="fst-italic">
                We appreciate you completing this SEO questionnaire. Your
                responses will help us tailor a strategy that aligns with your
                business goals.
              </p>
              <div className="d-flex">
                <p class="text-danger fw-bold" style={{ marginRight: ".3rem" }}>
                  Note:
                </p>
                <p class="fst-italic">
                  The information provided will be used for marketing purposes
                  to enhance your digital marketing and SEO efforts. We respect
                  your privacy and will use this data solely to offer the best
                  service.
                </p>
              </div>
            </div>
          </div>
          <div className="text-center">
            <ReCAPTCHA
              sitekey={"6LfrdtUqAAAAAFb4hjwtai1FHpMgpU76t_oQNuuK"}
              ref={recaptcha}
            />
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </Layout>
  );
}

export default SeoQuestionnaireForm;
